export default "/_next/static/chunks/fonts/RobotoMono-Medium-63c9982ca734f8dd2ea9f9d0a0ba91d2.woff";